import * as React from 'react'

import {
  makeStyles,
  Button,
  Spinner
} from '@fluentui/react-components'
import { useMsal } from '@azure/msal-react'

import SearchBox from '../components/SearchBox'
import { SORT_MENU_DEFAULT_VALUES } from '../constants/sort-menu'
import style from '../styles/button'

import { getAccessToken } from '../../auth/msal'
import { fetchMessages } from '../../services/message'
import { isK2IdValid, k2IdHistoryAppendItem } from '../../utils/search'

const { searchButton } = style

const useStyles = makeStyles({ searchButton })

const SearchBoxContainer = ({
  messages,
  setMessages,
  searchParams,
  setSearchParams,
  setHasMoreMessages,
  setError
}) => {
  const classes = useStyles()

  const { instance } = useMsal()

  const [k2IdInput, setK2IdInput] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [filterInputs, setFilterInputs] = React.useState({})
  const [sortInput, setSortInput] = React.useState(SORT_MENU_DEFAULT_VALUES)

  let k2IdHistoryItems = JSON.parse(window.localStorage.getItem('k2IdHistory'))

  if (!Array.isArray(k2IdHistoryItems)) {
    k2IdHistoryItems = []
  }

  const [k2IdHistory, setK2IdHistory] = React.useState(k2IdHistoryItems)

  const onSearch = async (inputs) => {
    setK2IdHistory(prev => k2IdHistoryAppendItem(prev, k2IdInput))

    if (!isK2IdValid(k2IdInput)) {
      setError('K2 ID is not valid.')
      return
    }

    setLoading(true)

    try {
      const params = {
        k2Id: k2IdInput,
        offset: 0,
        sortBy: sortInput.sortBy[0],
        sortOrder: sortInput.sortOrder[0],
        ...filterInputs
      }
      const accessToken = await getAccessToken(instance)
      const response = await fetchMessages(accessToken, params)

      setSearchParams(params)
      setMessages(response.data)
      setHasMoreMessages(true)
    } catch (error) {
      setError('An error occurred while fetching emails')
    }

    setLoading(false)
  }

  const resetSearch = () => {
    setMessages([])
    setError(null)
  }

  const handleKeyDown = React.useCallback((event) => {
    if (event.key === 'Enter' && k2IdInput.trim()) {
      event.preventDefault()
      onSearch()
    }
  }, [k2IdInput])

  React.useEffect(() => {
    window.localStorage.setItem('k2IdHistory', JSON.stringify(k2IdHistory))
  }, [k2IdHistory])

  return (
    <>
      <SearchBox
        k2IdHistory={k2IdHistory}
        setK2IdInput={setK2IdInput}
        sortInput={sortInput}
        setSortInput={setSortInput}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        onKeyDown={handleKeyDown}
        setError={setError}
      />
      <Button
        className={classes.searchButton}
        icon={loading ? <Spinner size='tiny' /> : null}
        appearance='primary'
        onClick={onSearch}
        disabled={!k2IdInput}
      >
        Search
      </Button>
      <Button
        className={classes.searchButton}
        onClick={resetSearch}
        disabled={messages.length === 0}
      >
        Reset search
      </Button>
    </>
  )
}

export default SearchBoxContainer
